import { observer } from 'mobx-react-lite'
import { Button } from 'components/Button'
import { useRootStore } from 'stores/RootStore'

export const ResetOverridesButton = observer(() => {
  const rootStore = useRootStore()
  const featureFlagStore = rootStore.featureFlags

  return (
    <Button size="xl" onPress={() => featureFlagStore.reset()}>
      Reset All Overrides
    </Button>
  )
})
